/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 * Method enumerates supported payment methods.

 - METHOD_UNSPECIFIED: Default value. Should not be used explicitly.
 - METHOD_CARD: Payment made using a bank card (e.g., Visa, MasterCard).
 - METHOD_SBP: Payment made via SBP (Russian Faster Payments System).
 - METHOD_CRYPTO: Payment made using cryptocurrencies.
 - METHOD_WALLET: Payment made using a digital wallet.
 - METHOD_QR: Payment via QR-Code
 */
export enum UniteTypePaymentMethod {
    METHOD_UNSPECIFIED = 'METHOD_UNSPECIFIED',
    METHOD_CARD = 'METHOD_CARD',
    METHOD_SBP = 'METHOD_SBP',
    METHOD_CRYPTO = 'METHOD_CRYPTO',
    METHOD_WALLET = 'METHOD_WALLET',
    METHOD_QR = 'METHOD_QR',
}
